// src/components/dentally/DentallyNextBookingChip.jsx
//
// Hero pill: the selected treatment's next active booking with its provider
// state (CRM only / Dentally booking / pending / needs review). Amber when the
// Dentally outcome needs attention. Separate fact from the patient-link chip.
// Click deep-links to that exact treatment + appointment in the Treatments tab.
import PropTypes from 'prop-types';
import { Box, Tooltip, Zoom } from '@mui/material';
import Iconify from '../Iconify';
import { pillBadge } from '../../styles/LeadDetailView';
import { TONE_COLOURS } from '../../utils/dentallyPatientLinkStatus';
import { getDentallyAppointmentPresentation } from '../../utils/dentallyAppointmentStatus';
import { formatBookingWhen } from '../../utils/nextTreatmentBooking';

export default function DentallyNextBookingChip({ appointment, others, treatmentName, onClick }) {
  if (!appointment) return null;
  const provider = getDentallyAppointmentPresentation(appointment.dentally);
  const colours = TONE_COLOURS[provider.tone === 'warning' ? 'warning' : 'neutral'];
  const when = formatBookingWhen(appointment);
  const label = `Next: ${when || 'date unknown'} · ${provider.label}${others > 0 ? ` +${others}` : ''}`;
  const tooltip = `${treatmentName ? `${treatmentName} — ` : ''}${provider.tooltip}${others > 0 ? ` ${others} more upcoming booking${others === 1 ? '' : 's'} for this treatment.` : ''} Open the appointment.`;

  return (
    <Tooltip title={tooltip} placement="bottom" TransitionComponent={Zoom} TransitionProps={{ timeout: 300 }}>
      <Box
        role="button"
        tabIndex={0}
        aria-label={`Next booking ${when || ''} ${provider.label}. Open appointment`}
        data-testid="dentally-next-booking-chip"
        data-state={provider.key}
        onClick={onClick}
        onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onClick?.(event); } }}
        sx={{ ...pillBadge(colours.bg, colours.fg), cursor: 'pointer' }}
      >
        <Iconify icon={provider.tone === 'warning' ? 'mdi:alert-circle-outline' : 'mdi:calendar-clock-outline'} width={16} height={16} />
        {label}
      </Box>
    </Tooltip>
  );
}

DentallyNextBookingChip.propTypes = {
  appointment: PropTypes.shape({ id: PropTypes.number, datetime: PropTypes.string, dentally: PropTypes.object }),
  others: PropTypes.number,
  treatmentName: PropTypes.string,
  onClick: PropTypes.func,
};

DentallyNextBookingChip.defaultProps = { appointment: null, others: 0, treatmentName: '', onClick: undefined };
